import React from "react";
import { Box, Grid } from "@mui/material";
import { antiFlashWhite, mainFont } from "../../utils/StyleHelpers";

const BoxComponent = ({ body }: any) => {
  return (
    <Grid container sx={{ minHeight: "100vh", marginTop: "3.125rem" }}>
      <Grid item xs={12} sx={{ minHeight: "100vh" }}>
        <Box
          sx={{
            background: antiFlashWhite,
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span
            style={{
              fontFamily: mainFont,
              fontWeight: 400,
              fontSize: "2rem",
              color: "#00000080",
            }}
          >
            {body}
          </span>
        </Box>
      </Grid>
    </Grid>
  );
};

export default BoxComponent;
